import { render, staticRenderFns } from "./IconHero.vue?vue&type=template&id=19d28d51"
import script from "./IconHero.vue?vue&type=script&lang=js"
export * from "./IconHero.vue?vue&type=script&lang=js"
import style0 from "./IconHero.vue?vue&type=style&index=0&id=19d28d51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports